import React from "react";
import './services.css';
import {
    Row,
    Col,
    Form,
    FormControl,
    InputGroup,
    Button,
    Container
} from "react-bootstrap";
import DataTable from "../../components/ServiceTable";
import { useNavigate } from 'react-router-dom';
import NavigationBar from "../../components/NavigationBar";

function ServicesPage() {

    const navigate = useNavigate();
    const handleSubmitSearch = () => {
        console.log('searching')
    }

    const handleAddService = () => {
        navigate('/addservice');
    }

    return (
        <>
        <NavigationBar fluid title1={'Services'} title2={'Sponsors'} toggleNav={true} />
            <Container className="services-container mt-4">
                <Row className="services-container d-flex justify-content-center hiddenOverflow" id="services">
                    <Col xs={12} md={10} lg={9}>
                        <Row className="mx-lg-1 mx-2 mt-3 mb-3">
                            <Col>
                                <h2 className="bold">Services</h2>
                            </Col>

                            <Col className="d-flex justify-content-end">
                                <Button onClick={handleAddService}>Add</Button>

                            </Col>
                        </Row>
                        <Row className="mx-lg-1 mx-2 mb-3">
                            <Form onSubmit={handleSubmitSearch}>
                                <InputGroup className="mb-3 search-bar">
                                    <InputGroup.Text className="search-icon">
                                        {/* <FontAwesomeIcon icon={faSearch} /> */}
                                    </InputGroup.Text>
                                    <FormControl
                                        className="search-bar"
                                        type="text"
                                        placeholder="Search for services... "
                                        aria-label="Search"
                                    // onChange={(e)=> setSearchTerm(e.target.value)}
                                    />
                                </InputGroup>
                            </Form>
                        </Row>

                    </Col>
                </Row>
                <DataTable />

            </Container>
        </>
    )
}

export default ServicesPage
